import React, { useState } from 'react';
import _ from 'lodash';
import TagBox from '../../components/TagBox';
import { navigateToChat } from '../NavigateToChat';
import CallBookingModal from '../CallBookingModal';
import { Box, Link, Typography } from '@mui/material';
import { useModule } from '../../../../utils/useModule';
import MySkeleton from '../../../../components/Skeleton';
import { useNavigate, useLocation } from 'react-router-dom';
import ChatAvatarComponent from '../chat/ChatAvatarComponent';
import { ChatIcon, VideoCallIcon } from '../../../../utils/Icons';
import { useAppSelector, useAppDispatch } from '../../../../redux/hooks';
import { getDisplayName, GroupBasedRoleFormatter } from '../../components/common';
import useResponsiveScreenSwitch from '../../../../utils/useResponsiveScreenSwitch';

interface MyMentorCardProps {
  mentor: any;
  loading?: boolean;
  myRequestedMentorList?: any;
  doReload?: () => void;
  onMeetingScheduled?: (meetingDetails: any) => void;
}

const MentorCard: React.FC<MyMentorCardProps> = ({
  mentor,
  loading,
  myRequestedMentorList,
  doReload,
  onMeetingScheduled
}: MyMentorCardProps) => {
  const navigate = useNavigate();
  const { isHybrid } = useModule();
  const dispatch = useAppDispatch();
  const bookedCallDetails: any = '';
  const [openCalendarModalVal, setCalendarOpen] = useState(false);
  const [displayName, setDisplayName] = useState('');
  const [participantUser, setParticipantUser] = useState([]);
  const personalThreadsArr = useAppSelector((state) => state.acsChannels.personalThreadsArr);
  const communityMembers = useAppSelector((state) => state.acsCommunityUsers.data);
  const commList = useAppSelector((state) => state.getCommunityMembers.data);
  const isMatchCancelled = _.get(mentor, 'isCancelled', false);

  /** For responsive */
  const { forMobile } = useResponsiveScreenSwitch(); // Use the hook
  const mentorRoleText = GroupBasedRoleFormatter('mentor', 'Mentor'); // Mentor
  const mentorRoleTextLowerCase = mentorRoleText.toLowerCase(); // mentor
  const { state } = useLocation();

  // Redirect community profile
  const moveToUsercommunityProfile = (userId: string) => {
    const mem = communityMembers.find((item: { userId: string }) => item.userId === userId);
    const modifiedMem = { ...mem, id: _.get(mem, 'id.coId', '') };
    const allCommunityMembersList = communityMembers;
    if (mem) {
      navigate('/app/communitymember', {
        state: { mem: modifiedMem, allCommunityMembersList: commList }
      });
    }
  };

  // Navigate To hat
  const handleNavigateToChat = (member: any) => {
    const listedInCommunity = communityMembers?.find((each) => each?.userId === _.get(member, 'userId', ''));
    let isInCommunity = false;
    if (listedInCommunity) {
      isInCommunity = true;
    }
    navigateToChat(member?.communicationId, isInCommunity, personalThreadsArr, navigate, dispatch);
  };

  /** Calendar modal */
  // const handleCalendarOpen = (member: any) => {
  //   setDisplayName(member.displayName);
  //   setParticipantUser(member);
  //   setCalendarOpen(true);
  // };

  // Calendar Close
  const handleCalendarClose = () => {
    setDisplayName('');
    setParticipantUser([]);
    setCalendarOpen(false);
  };

  const imgSize = '56px'; //forMobile ? '56px' : '90px'
  const getWidth = isHybrid ? '199px' : '320px';

  return (
    <>
      <Box
        gap="8px"
        display="flex"
        width={forMobile ? '100%' : getWidth}
        minWidth={forMobile ? '100%' : getWidth}
        flexDirection={forMobile ? 'row' : 'column'}
      >
        <Box
          gap={1.5}
          display="flex"
          width={'100%'}
          alignItems="flex-start"
          flex={forMobile ? 1 : ''}
          className="cursor-pointer"
          onClick={() => handleNavigateToChat(mentor)}
        >
          <Box onClick={() => moveToUsercommunityProfile(mentor?.userId)}>
            <ChatAvatarComponent
              image={mentor?.headshot}
              type="noStatus"
              firstLetter={getDisplayName(mentor).charAt(0)}
              width={imgSize}
              height={imgSize}
              cursor="pointer"
              loading={loading}
            />
          </Box>
          <Box flex={1} width={`calc(100% - (${imgSize} + 15px))`}>
            {/* Mobile else Desktop */}
            <Box className="cursor-pointer" width="100%">
              <Box display="flex" gap="8px" alignItems="center" justifyContent="space-between">
                <Typography variant="h5" noWrap onClick={() => moveToUsercommunityProfile(mentor?.userId)}>
                  {loading ? <MySkeleton width={forMobile ? 100 : 150} /> : getDisplayName(mentor)}
                </Typography>
              </Box>
              <Typography className="lineClamp-2">
                {loading ? (
                  <MySkeleton width={150} />
                ) : (
                  <>
                    {mentor?.category}
                    <br />
                    {mentor?.timezone}
                    {/* Lorem ipsum dolor sit amet consectetur adipisicing elit orem ipsum dolor sit amet
                    consectetur adipisicing elitorem ipsum dolor sit amet consectetur adipisicing elit. */}
                  </>
                )}
              </Typography>

              {/* <Typography mt={1} fontStyle={'italic'} className='lineClamp-2'>
                Litttle bio we will give here to cover space may be from her/his profile first 1 or 2 line then Litttle bio we will give here to cover space may be from her/his profile firs
              </Typography> */}
            </Box>
          </Box>
        </Box>

        {/* Only For Mobile else dasktop */}
        {forMobile ? (
          isMatchCancelled && (
            <Box display="flex" alignItems="center" gap="8px">
              {loading ? (
                <>
                  <MySkeleton variant="circular" height={25} width={25} />
                  {/* <MySkeleton variant="rounded" height={25} width={25} /> */}
                </>
              ) : (
                <>
                  <ChatIcon
                    size={21}
                    disabled
                    onClick={() => {
                      handleNavigateToChat(mentor);
                    }}
                  />
                  {/* <VideoCallIcon
                  size={21}
                  onClick={(event) => {
                    handleCalendarOpen(mentor);
                  }}
                /> */}
                </>
              )}
            </Box>
          )
        ) : (
          <Box ml={`calc(${imgSize} + 15px)`}>
            {isMatchCancelled ? (
              <TagBox text="Match Cancelled" color="#DF6438" />
            ) : (
              <Box display="flex" gap="16px" alignItems="center">
                {loading ? (
                  <>
                    <MySkeleton variant="rounded" height={30} width={120} />
                    {/* <MySkeleton variant="rounded" height={30} width={120} /> */}
                  </>
                ) : (
                  <>
                    <Box className="myMentorNewBtn" onClick={() => handleNavigateToChat(mentor)}>
                      <ChatIcon size={21} disabled />
                      {/* <Link fontWeight={'600'}>Message</Link> */}
                    </Box>
                    {/* <Box className="myMentorNewBtn" onClick={() => handleCalendarOpen(mentor)}>
                      <VideoCallIcon size={21} />
                      <Link fontWeight={'600'}>Schedule</Link>
                    </Box> */}
                  </>
                )}
              </Box>
            )}
          </Box>
        )}
      </Box>

      {/* Call booking modal */}
      <CallBookingModal
        handleCloseModal={handleCalendarClose}
        openFlag={openCalendarModalVal}
        chatProfileName={displayName}
        threadParticipantsUsers={[participantUser]}
        chatType="Chats"
        pageName="Mentor"
        bookedCallDetails={bookedCallDetails}
        onMeetingScheduled={onMeetingScheduled}
      />
    </>
  );
};

export default MentorCard;
